import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DialogService } from 'primeng/dynamicdialog';
import { defaultListPaginationParameters } from '../../../data-access';
import { SoftDeletableAuditableLookupsComponent } from '../../../lookups';
import { ActionConfigFactory, ActionTypeEnum, ActionTypeHandlerEnum, IActionConfig } from '../../../ui';
import { DistrictsApiClientProvider, IDistrictsApiClient } from '../clients';
import { IDistrictResponse } from '../dtos';
import { LocationManagementPermissions } from '../../common/permissions';
import { CreateUpdateDistrictComponent } from '../../../../../trash/location-management/districts/components/create-update-district/create-update-district.component';

@Component({
  selector: 'app-districts',
  standalone: true,
  providers: [],
  imports: [CommonModule, SoftDeletableAuditableLookupsComponent],
  templateUrl: './districts.component.html',
  styleUrls: ['./districts.component.scss']
})
export class DistrictsComponent {
  client: IDistrictsApiClient = inject(DistrictsApiClientProvider).getClient();
  dialogService = inject(DialogService);
  translate = inject(TranslateService);
  router = inject(Router);
  defualtPaginationParameters = defaultListPaginationParameters;

  supportedActions: IActionConfig<IDistrictResponse>[] = [
    ActionConfigFactory.createDialog(this.dialogService, {
      type: ActionTypeEnum.VIEW,
      componentType: CreateUpdateDistrictComponent,
      headerResolver: (x) =>
        `${this.translate.instant('LOCATION_MANAGEMENT.DISTRICT')} ${this.translate.currentLang === 'ar' ? `'${x!.arabicName}'` : `'${x!.englishName}'`
        }`,
      permission: LocationManagementPermissions.Districts.Read
    }),
    {
      type: ActionTypeEnum.CREATE,
      label: `${this.translate.instant('GENERAL.CREATE')} ${this.translate.instant('LOCATION_MANAGEMENT.NEW_DISTRICT')}`,
      handlerType: ActionTypeHandlerEnum.DIALOG,
      handlerConfig: {
        componentType: CreateUpdateDistrictComponent,
        configResolver: (item?: IDistrictResponse) => ({
          data: {
            item: item,
            visible: true
          },
          header: `${this.translate.instant('GENERAL.CREATE')} ${this.translate.instant('LOCATION_MANAGEMENT.DISTRICT')}`
        }),
        service: this.dialogService
      },
      permission: LocationManagementPermissions.Districts.Create
    },
    {
      type: ActionTypeEnum.UPDATE,
      handlerType: ActionTypeHandlerEnum.DIALOG,
      handlerConfig: {
        componentType: CreateUpdateDistrictComponent,
        configResolver: (item?: IDistrictResponse) => ({
          data: {
            item: item,
            visible: true
          },
          header: `${this.translate.instant('LOCATION_MANAGEMENT.DISTRICT')} ${this.translate.currentLang === 'ar' ? `'${item!.arabicName}'` : `'${item!.englishName}'`
            }`,
        }),
        service: this.dialogService
      },
      permission: LocationManagementPermissions.Districts.Update
    }
  ];
}
